import axios from 'axios'
import apiMonitorHelper from '@lib/business/apiMonitorHelper.js'
import Cookies from 'js-cookie'
import Vue from 'vue'

export default {
  get(url, opts) {
    return this.axios('get', url, { params: opts })
  },
  post(url, opts) {
    return this.axios('post', url, { data: opts })
  },
  axios(method, url, opts) {
    const { params = {}, ...others } = opts
    const userId = Cookies.get(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserId`)
    const userToken = Cookies.get(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserToken`)

    const ajaxRequest = axios({
      method,
      url: url,
      timeout: 20 * 1000,
      params: {
        ...params,
        _apitsp: new Date().getTime()
      },
      ...others
    })

    return ajaxRequest.then((ret) => {
      const newUserId = Cookies.get(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserId`)
      const newUserToken = Cookies.get(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserToken`)

      if (userId && userId !== 'undefined' && userId + '' !== '0' && userId !== newUserId) {
        Vue.prototype.$tjReport({ msg: 'Cookie token be clean by server', data: { oldUserId: userId, newUserId } })
      }
      if (userToken && userToken !== 'undefined' && userToken + '' !== '0' && userToken !== newUserToken) {
        Vue.prototype.$tjReport({ msg: 'Cookie token be clean by server', data: { oldUserToken: userToken, newUserToken } })
      }

      if (ret.status === 200) {
        if (ret.data && !ret.data.ret) {
          apiMonitorHelper.apiMonitor(url, ret.data, ret.data.errcode || 'cms-http-response-error')
        }
        return Promise.resolve(ret.data)
      } else {
        return Promise.resolve(null)
      }
    })
  }
}

/**
[tjReport 业务报警]
@param  {[string]} msg 报警消息，英文，用于报警消息&消息聚合，内容要求可以精确定位这个业务
@param  {[object]} data 报警数据
@param  {[string]} tipMsg 用户提示，非阻断的报警可以使用tips提示
@param  {[string]} altMsg 用户弹层提示，阻断用户操作，需要使用alt，比如必要参数缺少
*/
Vue.prototype.$tjReport = function({ msg, data, tipMsg, altMsg }) {
  if (tipMsg) {
    Vue.prototype.$tips(tipMsg)
  }
  if (altMsg) {
    Vue.prototype.$dialog({
      title: '异常提示',
      message: altMsg,
      showCancelButton: false
    })
  }
  window._fas && window._fas.setCustomError({ message: msg, error: data })
}
